import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import DOMPurify from 'dompurify';

@Component({
  selector: 'store-selling-info',
  template: `
    @if (description) {
      <section class="resize" [innerHtml]="filterDescription | iTrustThisHtml"></section>
    }
    @if (keySellingPoints && keySellingPoints.length > 0) {
      <section class="key-selling-points">
        @for (ksp of keySellingPoints; track ksp) {
          <div class="key-selling-point">
            <mat-icon>check_circle</mat-icon>
            {{ ksp }}
          </div>
        }
      </section>
    }
    `,
  styleUrls: ['./selling-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VaSellingInfoComponent {
  @Input() description: string;
  @Input() keySellingPoints: string[];

  get filterDescription(): string {
    const cons = sanitizeSellingInfoDescription(this.description);
    //TODO LB-2429 Hardcoded conversion from gmb to gbp . Should be revisited
    const re = /Google My Business/gi;
    const gmbReplaced: string = cons.replace(re, 'Google Business Profile');
    return gmbReplaced;
  }
}

export function sanitizeSellingInfoDescription(description: string | string): string {
  let desc = description.replace(/max-width:\d*[^"]/i, 'max-width:100%');

  if (desc.indexOf('"max-width:100%"') === -1 && desc.indexOf('<iframe ') !== -1) {
    const index = desc.indexOf('<iframe ') + 7;
    desc = desc.substr(0, index) + ' style="max-width:100%"' + desc.substr(index);
  }

  DOMPurify.addHook('afterSanitizeAttributes', function (node: Element): void {
    if (node.nodeName === 'A') {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  });

  return String(
    DOMPurify.sanitize(desc, {
      ADD_TAGS: ['iframe'],
      ADD_ATTR: [
        'allowfullscreen',
        'allowtransparency',
        'class',
        'frameborder',
        'height',
        'name',
        'scrolling',
        'style',
        'title',
        'width',
      ],
    }),
  );
}
